<template>
  <div class="box-subject">
    <p>
      <!-- 文字 -->
      <span
        :style="{
          display: 'inline-block',
          width: props.textWidth,
          'flex-shrink': 0,
          'text-align': 'right',
        }"
        >{{ props.filterButton.title }}：</span
      >
      <!-- 选项 -->
      <el-radio-group v-model="myModelValue" @change="checkListChange">
        <!-- 写死的全部 -->
        <el-radio-button
          class="index-is-0-btn"
          label="全部"
          value=""
          v-if="props.allBtnShow"
        ></el-radio-button>
        <!-- 动态的循环 -->
        <div class="other-btn">
          <el-radio-button
            v-for="(item, index) in props.filterButton.filter"
            :key="index"
            :label="item.label"
            :value="item.name"
          >
          </el-radio-button>
        </div>
      </el-radio-group>
    </p>
  </div>
</template>

<script setup>
import { reactive } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";

const mydata = reactive({
  checkAll: false,
  isIndeterminate: true,
  checkUnitValue: "",
  //   subjectButton: [
  //     "全部",
  //     "语文",
  //     "数学",
  //     "英语",
  //     "马克思",
  //     "历史",
  //     "测试一下多个文字比如二轮专题",
  //   ],
});

const myModelValue = defineModel("myModelValue");

const props = defineProps({
  filterButton: {
    type: Object,
    default: () => {
      return {};
    },
  },
  textWidth: {
    type: String,
    default: "45px",
  },
  allBtnShow: {
    type: Boolean,
    default: true,
  },
});

const emits = defineEmits(["change"]);

/** 多选框改变事件 */
// function checkListChange() {
//   // console.log("最终结果", mydata.checkUnitValue);
//   // 发送自定义事件
//   emits("change", mydata.checkUnitValue);
// }
</script>

<style scoped lang="scss">
.box-subject {
  > p {
    // width:32px;
    display: flex;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 32px;

    > span {
      // width: 44px;
      // border:1px solid red;
      font-size: 14px;
      margin-left: 16px;
    }
    :deep(.el-radio-group) {
      flex-wrap: nowrap;
      margin-right: 16px;
      // border:1px solid blue;
    }
    :deep(.el-button) {
      height: 32px;
      border-radius: 4px;
      border: 1px solid #009de0;
      color: #ffffff;
      font-size: 14px;
      font-weight: 400;
      line-height: 32px;
      margin-right: 15px;
      // border:1px solid rgb(60, 255, 0);
    }

    :deep(.el-radio-button) {
      padding: 4px 14px;
      // height: 28px;
      height: 32px;
      // border-radius: 4px;

      // border:1px solid #D9D9D9CC;
      // margin-right: 15px;
      // border:1px solid red;
      border: 1px solid #009de0;
      border: none;
      min-width: 64px;
      padding: 0;
    }

    :deep(.el-radio-button__inner) {
      // color:red;
      font-size: 14px;
      font-weight: 400;
      height: 32px;
      border-color: #d9d9d9cc;
      border: none;

      font-size: 14px;
      font-weight: 400;
      border-color: rgba(217, 217, 217, 0.8);
      border: none;
      background: transparent;
      // border: 1px solid #009DE0;
      width: 100%;
      height: 100%;
      text-align: center;
      line-height: 32px;
      padding: 0 10px;
      // border-left-color: #009DE0 !important;
      color: #333;
      border-radius: 4px;
      border: none !important;
      box-shadow: none;
    }
    // :deep(.el-radio-button.is-active){
    //     border:1px solid black;
    // }
    :deep(.el-radio-button.is-active.index-is-0-btn .el-radio-button__inner) {
      background: #009de0;
      color: #fff;
    }
    :deep(.el-radio-button.is-active .el-radio-button__inner) {
      border: 1px solid #009de0 !important;
      color: #009de0;
    }
  }
}

.other-btn {
  width: 250px;
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  // border: 1px solid blue;

  :deep(.el-radio-button) {
    flex-wrap: nowrap !important;
  }
}

/* 针对webkit内核浏览器 */
.other-btn::-webkit-scrollbar {
  display: none !important; /* 隐藏滚动条 */
}
.other-btn::-webkit-scrollbar-thumb {
  display: none !important; /* 隐藏滚动条 */
}

.other-btn {
  /* 针对Firefox */
  scrollbar-width: none; /* Firefox中隐藏滚动条 */

  /* 针对IE和Edge */
  -ms-overflow-style: none; /* IE和Edge中隐藏滚动条 */
}
</style>

<!-- 1.边框怎末这样，怎么了 设计图没有边框呀，小按钮的边框知道了 -->
<!-- 2.点击全选 或反选 会报错 -->
<!-- 可以了 -->
